import firebase from 'firebase';
import React, { useState, useEffect } from 'react';
import './dashboard.scss';

const firebaseConfigDashboard = {
  apiKey: 'AIzaSyDhHTJ-yxU0h7VI1z6xJuTsdc-LVdA773M',
  authDomain: 'atresmicroserviciosdes.firebaseapp.com',
  databaseURL: 'https://atresmicroserviciosdes-controlpanel.firebaseio.com/',
  projectId: 'atresmicroserviciosdes',
  storageBucket: 'atresmicroserviciosdes.appspot.com',
  messagingSenderId: '574492392308'
};

const CELL_STYLE = { width: 100, height: 30, fontSize: 12 };

const getStyle = state => {
  switch (state) {
    case 'ERROR':
      return {
        color: 'white',
        backgroundColor: '#d50000'
      };
    case 'FINISH':
      return {
        color: 'white',
        backgroundColor: '#43a047'
      };
    case 'WORKING':
      return {
        color: 'black',
        backgroundColor: '#fbc02d'
      };
    default:
    case 'NOT_STARTED':
      return {
        color: 'white',
        backgroundColor: '#616161'
      };
  }
};

const Label = ({ children }) => {
  return (
    <div className="label" style={getStyle(children)}>
      {children}
    </div>
  );
};

const ProgressLabel = ({ children, percent = 0 }) => {
  return (
    <div
      className="label"
      style={{
        backgroundImage: `linear-gradient(to right, #03a9f4, #03a9f4 ${percent -
          10}%, #e5e5e5 ${percent}%, #e5e5e5)`
      }}
    >
      {children}
    </div>
  );
};

function msToSsMmm(ms) {
  const seconds = Math.floor(ms / 1000); // Obtener la parte entera de los segundos
  const milliseconds = ms % 1000; // Obtener los milisegundos restantes

  // Formatear los milisegundos con tres decimales
  const formattedMilliseconds = milliseconds.toFixed(0);

  // Formatear el resultado como ss.mmm
  const result = seconds + ':' + formattedMilliseconds;
  return result;
}

const Dashboard = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    const app = firebase.initializeApp(firebaseConfigDashboard, 'dashboard');
    const reference = app.database().ref();
    reference.on('value', rawData => {
      const data = rawData.val();
      if (data) {
        setData(data);
      }
    });
    return () => {
      reference.off();
    };
  }, []);

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://use.fontawesome.com/releases/v5.8.2/css/all.css';
    document.head.appendChild(link);
  }, []);

  if (!data) return <div>Cargando...</div>;

  return (
    <div className="dashboard-panel">
      <h1>Dashboard</h1>
      <table>
        <tr>
          <th>Key</th>
          <th>Download Totals</th>
          <th>Desproduccion</th>
          <th>Process Region</th>
          <th>Firebase Region</th>
          <th>downloadTowns</th>
          <th>processTowns</th>
          <th>firebaseTowns</th>
          <th>Current Count</th>
          <th>Current File Time</th>
          <th>Current Process Time</th>
          <th>Last Count</th>
          <th>Last Filetime</th>
          <th>Last Process Time</th>
        </tr>
        {Object.keys(data).map(key => (
          <tr key={key}>
            <td>{key}</td>
            <td>
              <Label>{data[key].downloadTotals}</Label>
            </td>
            <td>
              <Label>{data[key].desproduccion}</Label>
            </td>
            <td>
              <Label>{data[key].processRegion}</Label>
            </td>
            <td>
              <Label>{data[key].firebaseRegion}</Label>
            </td>
            <td>
              <Label>{data[key].downloadTowns}</Label>
            </td>
            <td>
              <Label>{data[key].processTowns}</Label>
            </td>
            <td>
              <Label>{data[key].firebaseTowns}</Label>
            </td>
            <td>
              <ProgressLabel percent={data[key].currentCount}>
                {Number(data[key].currentCount).toLocaleString({
                  minimumFractionDigits: 2
                })}
                %
              </ProgressLabel>
            </td>
            <td>
              {data[key].currentFileTime === 0
                ? 'N/A'
                : data[key].currentFileTime}
            </td>

            <td>
              {data[key].currentProcessTime === 0
                ? 'N/A'
                : msToSsMmm(data[key].currentProcessTime)}
            </td>
            <td>
              <ProgressLabel percent={data[key].lastCount}>
                {Number(data[key].lastCount).toLocaleString({
                  minimumFractionDigits: 2
                })}
                %
              </ProgressLabel>
            </td>
            <td>{data[key].lastFileTime}</td>
            <td>
              <Label>{msToSsMmm(data[key].lastProcessTime)}</Label>
            </td>
          </tr>
        ))}
      </table>
    </div>
  );
};

export default Dashboard;
